import { gql } from 'graphql-request'

export namespace MarketSegmentQueries {
  export const QUERY_KEY = 'getMarketSegmentList'

  export function getMarketSegmentList() {
    return gql`
      {
        marketSegments {
          fieldOperationsHub
          fieldOperationsRegion
          marketSegmentType
          name
          id
        }
      }
    `
  }
}
